"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var CardRowButtonSet_1 = require("../../../../../../shared/components/editors/CardRowButtonSet");
var notificationHelper_1 = require("../../../../../../shared/helpers/notificationHelper");
var CardRowSelectEditor_1 = require("../../../../../../shared/components/editors/CardRowSelectEditor");
var CardEditorContainer_1 = require("../../../../../../shared/components/containers/CardEditorContainer");
var CardRowTextEditor_1 = require("../../../../../../shared/components/editors/CardRowTextEditor");
var CardRowNumericEditor_1 = require("../../../../../../shared/components/editors/CardRowNumericEditor");
var GameSetGamesBotWinsEditor = /** @class */ (function (_super) {
    __extends(GameSetGamesBotWinsEditor, _super);
    function GameSetGamesBotWinsEditor(props) {
        return _super.call(this, props) || this;
    }
    GameSetGamesBotWinsEditor.prototype.componentWillMount = function () {
        var _this = this;
        if (this.props.record) {
            var _item = this.props.data.getById(this.props.record.key);
            if (_item) {
                this.setState({
                    win_type_code: _item.win_type_code,
                    win_type_title: _item.win_type_title,
                    win_amount: _item.win_amount,
                    spin_count_next: _item.spin_count_next,
                    description: _item.description
                }, function () {
                    _this.props.state.setExtBreadCrumbPath(["Список выигрышей ботов", "Редактирование выигрыша"]);
                });
            }
        }
        else {
            this.setState({
                win_type_code: 0,
                win_type_title: "",
                win_amount: 0,
                spin_count_next: 0,
                description: ""
            }, function () {
                _this.props.state.setExtBreadCrumbPath(["Список выигрышей ботов", "Создание выигрыша"]);
            });
        }
        this.doReSetRules();
    };
    GameSetGamesBotWinsEditor.prototype.doReSetRules = function () {
        this.setState({
            win_type_rules: { isError: false },
            win_amount_rules: { isError: false },
            spin_count_next_rules: { isError: false }
        });
    };
    GameSetGamesBotWinsEditor.prototype.isDataValid = function () {
        this.doReSetRules();
        if ((this.state.win_type_code <= 0) || (this.state.win_type_title.length === 0)) {
            this.setState({ win_type_rules: { isError: true, errorMessage: "Тип выигрыша не выбран!" } });
            return false;
        }
        if (this.state.win_amount < 0) {
            this.setState({ win_amount_rules: { isError: true, errorMessage: "Выигрыш не заполнен!" } });
            return false;
        }
        if (this.state.spin_count_next < 0) {
            this.setState({ spin_count_next_rules: { isError: true, errorMessage: "Кол-во спинов не заполнено!" } });
            return false;
        }
        return true;
    };
    GameSetGamesBotWinsEditor.prototype.OnUpdateDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.EditData({
                key: this.props.record.key,
                win_amount: this.state.win_amount,
                spin_counts_next: this.state.spin_count_next,
                win_type_code: this.state.win_type_code,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Выигрыш бота для набора игр изменен!");
            });
        }
    };
    GameSetGamesBotWinsEditor.prototype.OnNewDataClick = function () {
        if (this.isDataValid()) {
            this.props.data.AddData({
                app_currency_id: this.props.appCurrencyId,
                gameprovider_gameset_game_id: this.props.rootRecord.key,
                win_amount: this.state.win_amount,
                spin_counts_next: this.state.spin_count_next,
                win_type_code: this.state.win_type_code,
                description: this.state.description
            }, function () {
                notificationHelper_1.default.ShowTextTopRightInfoNotify("Выигрыш бота для набора игр добавлен!");
            });
        }
    };
    GameSetGamesBotWinsEditor.prototype.OnGoBackClick = function () {
        if (this.props.onGoBack) {
            this.props.onGoBack();
        }
    };
    GameSetGamesBotWinsEditor.prototype.getFormTitle = function () {
        if (!this.props.record) {
            return "Новый выигрыш бота для набора игр";
        }
        else {
            return "Новый выигрыш бота для набора игр";
        }
    };
    GameSetGamesBotWinsEditor.prototype.render = function () {
        var _this = this;
        return (React.createElement(CardEditorContainer_1.default, { onGoBackClick: this.OnGoBackClick.bind(this), title: this.getFormTitle(), state: this.props.state, maxHeight: 400 },
            React.createElement(CardRowSelectEditor_1.default, { texts: { caption: "Тип выигрыша:", placeholder: "Выберите тип выигрыша" }, value: { key: this.state.win_type_code, value: this.state.win_type_title }, onValueChanged: function (newVal) {
                    _this.setState({
                        win_type_code: newVal.key,
                        win_type_title: newVal.value,
                        win_type_rules: { isError: false }
                    });
                }, items: this.props.availBotWinTypes, required: true, rules: this.state.win_type_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Выигрыш", placeholder: "Введите значение выигрыша" }, values: { max: 999999, min: 0.1, value: this.state.win_amount }, onValueChanged: function (newVal) {
                    _this.setState({
                        win_amount: newVal,
                        win_amount_rules: { isError: false }
                    });
                }, required: true, precision: 2, rules: this.state.win_amount_rules }),
            React.createElement(CardRowNumericEditor_1.default, { texts: { caption: "Кол-во спинов", placeholder: "Введите количество спинов" }, values: { max: 1000, min: 1, value: this.state.spin_count_next }, onValueChanged: function (newVal) {
                    _this.setState({
                        spin_count_next: newVal,
                        spin_count_next_rules: { isError: false }
                    });
                }, required: true, precision: 0, rules: this.state.spin_count_next_rules }),
            React.createElement(CardRowTextEditor_1.default, { texts: { caption: "Описание:", placeholder: "Введите описание" }, value: this.state.description, onValueChanged: function (newVal) {
                    _this.setState({
                        description: newVal,
                    });
                } }),
            React.createElement(CardRowButtonSet_1.default, { editMode: this.props.record != null, title: { btnEdit: "Сохранить", btnNew: "Создать", btnGoBack: "Вернуться" }, onGoBackClick: this.OnGoBackClick.bind(this), onAddClick: this.OnNewDataClick.bind(this), onEditClick: this.OnUpdateDataClick.bind(this) })));
    };
    return GameSetGamesBotWinsEditor;
}(React.Component));
exports.default = GameSetGamesBotWinsEditor;



//////////////////
// WEBPACK FOOTER
// ./src/ui_admin/components/pages/cms_gamesets_list/ui/component/GameSetGamesBotWinsEditor.tsx
// module id = 2006
// module chunks = 0